<app-page-layout 
  [title]="title"
  [subtitle]="subtitle"
  [phoneNumber]="phoneNumber"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs"
  [prevPage]="prevPage"
  [nextPage]="nextPage">

  <!-- Tab Navigation -->
  <div class="devis-tabs-container">
    <nav class="devis-tabs">
      <a *ngFor="let tab of devisTabs" 
         [routerLink]="tab.route" 
         routerLinkActive="active"
         class="tab-item">
        <i class="pi" [ngClass]="tab.icon"></i>
        <span>{{ tab.label }}</span>
      </a>
    </nav>
  </div>

  <!-- Intro Section -->
  <div class="intro-section">
    <h2 class="intro-title">
      Obtenez votre <span class="highlight">devis personnalisé</span> en quelques minutes
    </h2>
    <p class="intro-text">
      Remplissez le formulaire ci-dessous pour recevoir une proposition adaptée à vos besoins
    </p>
  </div>

  <!-- Form Section -->
  <div class="form-section">
    <div class="form-container" *ngIf="!isSubmitted">
      <div class="form-header">
        <h2>DEMANDE DE DEVIS</h2>
        <p class="form-type">Mutuelle Santé Particulier</p>
      </div>

      <form [formGroup]="devisForm" (ngSubmit)="onSubmit()" class="devis-form">
        <!-- Civilité -->
        <div class="form-row">
          <div class="form-group">
            <label for="civilite">Civilité *</label>
            <select id="civilite" formControlName="civilite">
              <option value="">Sélectionnez</option>
              <option *ngFor="let c of civilites" [value]="c">{{ c }}</option>
            </select>
            <div class="error-message" *ngIf="devisForm.get('civilite')?.touched && devisForm.get('civilite')?.errors?.['required']">
              La civilité est requise
            </div>
          </div>
          <div class="form-group">
            <label for="dateNaissance">Date de naissance *</label>
            <input type="date" id="dateNaissance" formControlName="dateNaissance">
            <div class="error-message" *ngIf="devisForm.get('dateNaissance')?.touched && devisForm.get('dateNaissance')?.errors?.['required']">
              La date de naissance est requise
            </div>
          </div>
        </div>

        <!-- Nom & Prénom -->
        <div class="form-row">
          <div class="form-group">
            <label for="nom">Nom *</label>
            <input type="text" id="nom" formControlName="nom" placeholder="Votre nom">
            <div class="error-message" *ngIf="devisForm.get('nom')?.touched && devisForm.get('nom')?.errors?.['required']">
              Le nom est requis
            </div>
          </div>
          <div class="form-group">
            <label for="prenom">Prénom *</label>
            <input type="text" id="prenom" formControlName="prenom" placeholder="Votre prénom">
            <div class="error-message" *ngIf="devisForm.get('prenom')?.touched && devisForm.get('prenom')?.errors?.['required']">
              Le prénom est requis
            </div>
          </div>
        </div>

        <!-- Téléphone & Email -->
        <div class="form-row">
          <div class="form-group">
            <label for="telephone">Téléphone *</label>
            <input type="tel" id="telephone" formControlName="telephone" placeholder="06 12 34 56 78">
            <div class="error-message" *ngIf="devisForm.get('telephone')?.touched && devisForm.get('telephone')?.errors?.['required']">
              Le téléphone est requis
            </div>
            <div class="error-message" *ngIf="devisForm.get('telephone')?.touched && devisForm.get('telephone')?.errors?.['pattern']">
              Format invalide (10 chiffres)
            </div>
          </div>
          <div class="form-group">
            <label for="email">Email *</label>
            <input type="email" id="email" formControlName="email" placeholder="votre@email.com">
            <div class="error-message" *ngIf="devisForm.get('email')?.touched && devisForm.get('email')?.errors?.['required']">
              L'email est requis
            </div>
            <div class="error-message" *ngIf="devisForm.get('email')?.touched && devisForm.get('email')?.errors?.['email']">
              Format d'email invalide
            </div>
          </div>
        </div>

        <!-- Profession -->
        <div class="form-row full-width">
          <div class="form-group">
            <label for="profession">Profession *</label>
            <input type="text" id="profession" formControlName="profession" placeholder="Votre profession">
            <div class="error-message" *ngIf="devisForm.get('profession')?.touched && devisForm.get('profession')?.errors?.['required']">
              La profession est requise
            </div>
          </div>
        </div>

        <!-- Adresse -->
        <div class="form-row full-width">
          <div class="form-group">
            <label for="adresse">Adresse *</label>
            <input type="text" id="adresse" formControlName="adresse" placeholder="Votre adresse complète">
            <div class="error-message" *ngIf="devisForm.get('adresse')?.touched && devisForm.get('adresse')?.errors?.['required']">
              L'adresse est requise
            </div>
          </div>
        </div>

        <!-- Code Postal & Ville -->
        <div class="form-row">
          <div class="form-group">
            <label for="codePostal">Code postal *</label>
            <input type="text" id="codePostal" formControlName="codePostal" placeholder="75000">
            <div class="error-message" *ngIf="devisForm.get('codePostal')?.touched && devisForm.get('codePostal')?.errors?.['required']">
              Le code postal est requis
            </div>
            <div class="error-message" *ngIf="devisForm.get('codePostal')?.touched && devisForm.get('codePostal')?.errors?.['pattern']">
              Format invalide (5 chiffres)
            </div>
          </div>
          <div class="form-group">
            <label for="ville">Ville *</label>
            <input type="text" id="ville" formControlName="ville" placeholder="Votre ville">
            <div class="error-message" *ngIf="devisForm.get('ville')?.touched && devisForm.get('ville')?.errors?.['required']">
              La ville est requise
            </div>
          </div>
        </div>

        <!-- Pays -->
        <div class="form-row full-width">
          <div class="form-group">
            <label for="pays">Pays *</label>
            <select id="pays" formControlName="pays">
              <option *ngFor="let p of pays" [value]="p">{{ p }}</option>
            </select>
          </div>
        </div>

        <!-- Submit Button -->
        <div class="form-actions">
          <button type="submit" class="submit-btn" [disabled]="isSubmitting">
            <span *ngIf="!isSubmitting">Obtenir mon devis gratuit</span>
            <span *ngIf="isSubmitting" class="loading">
              <i class="spinner"></i> Envoi en cours...
            </span>
          </button>
        </div>

        <p class="form-info">
          * Champs obligatoires. Vos données sont protégées et ne seront jamais partagées avec des tiers.
        </p>

        <!-- Error Message -->
        <div class="error-container" *ngIf="errorMessage">
          <div class="error-alert">
            <i class="pi pi-exclamation-circle"></i>
            <span>{{ errorMessage }}</span>
          </div>
        </div>
      </form>
    </div>

    <!-- Success Message -->
    <div class="success-container" *ngIf="isSubmitted">
      <div class="success-icon">✓</div>
      <h2>Demande envoyée avec succès !</h2>
      <p>Nous avons bien reçu votre demande de devis. Un conseiller vous contactera dans les plus brefs délais.</p>
      <button class="new-request-btn" (click)="isSubmitted = false; devisForm.reset({pays: 'France'})">
        Faire une nouvelle demande
      </button>
    </div>
  </div>

</app-page-layout>
